"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.draftPolicyMtc = exports.sendMTCToUnderwriterSchema = void 0;
const policyAnnualCargoSchemas_1 = require("./policyAnnualCargoSchemas");
const joi_1 = __importDefault(require("joi"));
exports.sendMTCToUnderwriterSchema = joi_1.default.object({
    policyNumber: joi_1.default.string().required(),
    additionalComments: joi_1.default.string().allow(""),
    assured: joi_1.default.object({
        name: joi_1.default.string().required(),
        isUSDOTNotApplicable: joi_1.default.boolean().required(),
        motorCarrierNumber: joi_1.default.string().allow(""),
        freightForwarderNumber: joi_1.default.string().allow(""),
        usdot: joi_1.default.string()
    }),
    files: joi_1.default.array()
        .min(1)
        .required()
        .items(joi_1.default.object({
        documentPath: joi_1.default.string().required(),
        documentName: joi_1.default.string().required(),
        bucketName: joi_1.default.string(),
        size: joi_1.default.number(),
        fileType: joi_1.default.string(),
        downloadUrl: joi_1.default.string()
    }))
}).required();
exports.draftPolicyMtc = joi_1.default.object({
    channel: joi_1.default.string().required(),
    partnerIds: joi_1.default.object().required(),
    broker: policyAnnualCargoSchemas_1.brokerSchema.required()
}).required();
//# sourceMappingURL=mtcValidators.js.map